<template>
  <div class="WMap">
    <CallHelpTel />
    <div class="container">
      <div class="title">
        <div class="yellow"></div>
        <div class="article_T">
          <div class="subtitle" :style="{ fontSize: fontSize.h4 + 'em' }">
            網站安全政策
          </div>
        </div>
      </div>
      <div class="privacy_content">
        <div class="content_wrap">
          <div class="content_title">
            <div class="sec_title" :style="{ fontSize: fontSize.h5 + 'em' }">
              以下為網站安全政策資訊
            </div>
          </div>
          <div class="content_item">
            <div class="inside_title">
              <div :style="{ fontSize: fontSize.h5 + 'em' }">資訊安全政策</div>
            </div>
            <p :style="{ fontSize: fontSize.p + 'em' }">
              歡迎蒞臨「勞動部勞動力發展署國人海外就業服務中心網站」，為了幫助您瞭解「勞動部勞動力發展署國人海外就業服務中心網站」如何保護您在使用本網站各項服務的安全、及如何蒐集、應用及保護您所提供的個人資訊，請詳細閱讀以下「勞動部勞動力發展署國人海外就業服務中心網站」的資訊安全政策。若有任何意見，請至本網站信箱留言。
            </p>
          </div>
          <div class="content_item">
            <div class="inside_title">
              <div class="subtitle" :style="{ fontSize: fontSize.h5 + 'em' }">
                網路安全保護措施
              </div>
            </div>
            <p :style="{ fontSize: fontSize.p + 'em' }">
              一、任何未經授權而企圖上載或更改「勞動部勞動力發展署國人海外就業服務中心網站」所提供的各項服務及相關資訊的行為，都是嚴厲禁止而且可能觸犯法律。<br />
              二、為了網站安全的目的和確保這項服務能夠繼續服務所有的網路使用者，「勞動部勞動力發展署國人海外就業服務中心網站」提供了以下的安全保護措施：<br />
              1、使用網路入侵偵測系統，監控網路流量，以確認未經授權而企圖上載或更改、網頁資訊或蓄意破壞者。<br />
              2、裝設防火牆防止非法入侵、破壞或竊取或破壞資料，以避免網站遭到非法使用，以保障使用者的權益。<br />
              3、裝設掃毒軟體，定期掃毒，以提供使用者更安全的網頁瀏覽環境。<br />
              4、不定期摹擬駭客攻擊，演練發生安全事件時的系統回復程序，並提供適當的安全防禦等級。<br />
              5、每日進行備份作業，將所有資料備份到備援主機。<br />
              6、自動接收所有來自相關作業系統廠商或應用程式廠商所寄發的安全維護電子信通知，並依照電子信的建議，安裝適當的修改程式（PATCH）。
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { inject } from "vue";
import CallHelpTel from "../components/Home/CallHelpTel.vue";

export default {
  components: {
    CallHelpTel,
  },
  setup() {
    //  無障礙文字子層引入設定
    let fontSize = inject("fontSize");
    return {
      fontSize,
    };
  },
};
</script>

<style lang="scss" scoped>
.title {
  width: 100%;
  display: flex;
  .yellow {
    width: 3%;
    background-color: $main_sec_color;
  }
  .article_T {
    width: 100%;
    background-color: $main_color;
    padding: 20px;
    @include md {
      .subtitle {
        font-size: $p;
      }
    }
    .subtitle {
      color: #fff;
      text-align-last: left;
      margin-bottom: 0;
    }
  }
}
.content_wrap {
  width: 60%;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  align-content: flex-start;
  .content_title {
    margin: 15px 0;
    .sec_title {
      text-align: left;
      font-weight: 600;
    }
  }
  .content_item {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    margin-bottom: 30px;
    .inside_title {
      margin-bottom: 10px;
      border-bottom: 3px dotted $main_color;
    }
    h4 {
      text-align: left;
    }
    P {
      text-align: left;
    }
  }
}
</style>
